import palette from '../../../theme/palette';

export const styles = () => ({
  notificationIcon: {
    color: palette.secondary.main,
    fontSize: 28,
  },
});
